import { createContext } from 'react';
import type { TenantConfig } from '../types/tenant';

export type TenantStatus =
  | { kind: 'loading'; tenantId: string }
  | { kind: 'ready'; config: TenantConfig }
  | { kind: 'error'; tenantId: string; message: string };

export interface TenantConfigContextValue {
  status: TenantStatus;
  switchTenant: (id: string) => void;
}

export const TenantConfigContext = createContext<TenantConfigContextValue | null>(null);
